import React from "react";

const ProfEIntroQuotes: React.FC = () => (
  <section className="pe-section pe-section--cream pe-intro">
    <div className="pe-container">
      <div className="pe-intro__grid">
        <article className="pe-quote-card">
          <div className="pe-quote-card__mark" aria-hidden="true">
            66
          </div>
          <div className="pe-quote-card__attrib">Student</div>
          <h3 className="pe-quote-card__headline">
            &ldquo;I started asking myself <em>why</em>&hellip; not just what.&rdquo;
          </h3>
          <p className="pe-quote-card__body">
            Professor E creates a trusted, judgment-free space for students to articulate thoughts,
            process experiences, and develop metacognitive skills. It doesn&rsquo;t just answer &mdash;
            it listens, nudges, and reflects with them. Over time, students write more, think
            deeper, and take greater ownership of their learning journey.
          </p>
          <div
            className="pe-quote-card__mark pe-quote-card__mark--close"
            aria-hidden="true"
          >
            66
          </div>
        </article>

        <article className="pe-quote-card">
          <div className="pe-quote-card__mark" aria-hidden="true">
            66
          </div>
          <div className="pe-quote-card__attrib">Teacher</div>
          <h3 className="pe-quote-card__headline">
            &ldquo;It&rsquo;s like having 100 silent conversations brought to life.&rdquo;
          </h3>
          <p className="pe-quote-card__body">
            While students reflect, teachers gain visibility, real-time summaries, and
            self-defined thematic analysis without reading 100 essays. One professor described
            it as &ldquo;finally seeing the why behind the grade.&rdquo;
          </p>
          <div
            className="pe-quote-card__mark pe-quote-card__mark--close"
            aria-hidden="true"
          >
            66
          </div>
        </article>
      </div>
    </div>
  </section>
);

export default ProfEIntroQuotes;
